Object.defineProperty(exports, "__esModule", { value: true });
exports.compileAllInputFields = exports.compileAllInputFieldsForSingleTarget = exports.compileInputFieldConfig = void 0;
const graphql_1 = require("graphql");
const InputFieldDecorators_1 = require("../InputFieldDecorators");
const fieldType_1 = require("./fieldType");
const inheritance_1 = require("../../../services/utils/inheritance");
function getFinalInputFieldType(target, fieldName, explicitType) {
    if (explicitType) {
        return fieldType_1.resolveTypeOrThrow(explicitType, target, fieldName);
    }
    return fieldType_1.inferTypeOrThrow(target, fieldName);
}
function validateResolvedType(target, fieldName, type) {
    if (!graphql_1.isInputType(type)) {
        throw new InputFieldDecorators_1.InputFieldError(target, fieldName, `Validation of type failed. Resolved type must be a GraphQLInputType.`);
    }
    return true;
}
function enhanceType(originalType, isNullable) {
    let finalType = originalType;
    if (!isNullable) {
        finalType = new graphql_1.GraphQLNonNull(finalType);
    }
    return finalType;
}
function compileInputFieldConfig(target, fieldName) {
    const { type, description, defaultValue, isNullable } = InputFieldDecorators_1.inputFieldsRegistry.get(target, fieldName);
    const resolvedType = getFinalInputFieldType(target, fieldName, type);
    if (!validateResolvedType(target, fieldName, resolvedType)) {
        return;
    }
    resolvedType;
    const finalType = enhanceType(resolvedType, isNullable);
    return {
        description,
        defaultValue,
        type: finalType
    };
}
exports.compileInputFieldConfig = compileInputFieldConfig;
function compileAllInputFieldsForSingleTarget(target) {
    const fields = InputFieldDecorators_1.inputFieldsRegistry.getAll(target);
    const finalFieldsMap = {};
    Object.keys(fields).forEach((fieldName) => {
        const config = InputFieldDecorators_1.inputFieldsRegistry.get(target, fieldName);
        finalFieldsMap[config.name] = compileInputFieldConfig(target, fieldName);
    });
    return finalFieldsMap;
}
exports.compileAllInputFieldsForSingleTarget = compileAllInputFieldsForSingleTarget;
function compileAllInputFields(target) {
    const targetWithParents = inheritance_1.getClassWithAllParentClasses(target);
    const finalFieldsMap = {};
    targetWithParents.forEach((targetLevel) => {
        Object.assign(finalFieldsMap, compileAllInputFieldsForSingleTarget(targetLevel));
    });
    return finalFieldsMap;
}
exports.compileAllInputFields = compileAllInputFields;
//# sourceMappingURL=index.js.map